<template>
  <form @submit.prevent="submit">
    <FormField>
      <Input :invalid="$v.username.$error && !$v.username.required" v-model="$v.username.$model" placeholder="Email или телефон" />
      <Error v-if="$v.username.$error && !$v.username.required">
        Поле обязательнное
      </Error>
    </FormField>
    <FormField>
      <Input :invalid="$v.password.$error && !$v.password.required" v-model="$v.password.$model" placeholder="Пароль" type="password" />
      <Error v-if="$v.password.$error && !$v.password.required">
        Поле обязательнное
      </Error>
      <Error v-if="invalidGrant">
        Неверный логин или пароль
      </Error>
    </FormField>
    <SubmitButton :disabled="$v.username.$invalid || $v.password.$invalid">Войти</SubmitButton>
  </form>
</template>

<script>
import axios from 'axios';
import Input from '@app/components/uikit/Input';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import SubmitButton from './submit-button';

import { required } from 'vuelidate/lib/validators';
import { oauthApi, http, laravelHttp, refBookHttp, receptionHttp } from '@app/services';
import helper from '@app/services/helper';


export default {
  components: { Input, FormField, Error, SubmitButton },
  data: () => ({
    username: '',
    password: '',
    invalidGrant: false,
  }),
  validations: {
    username: { required },
    password: { required },
  },
  watch: {
    username() {
      this.invalidGrant = false;
    },
    password() {
      this.invalidGrant = false;
    }
  },
  methods: {
    async submit() {
      try {
        const token = await oauthApi.getTokenByForm(this.username, this.password);
        this.$emit('success');
        await this.setToken(token);
        this.username = '';
        this.password = '';
      } catch (err) {
        const errorType = err?.response?.data?.error;
        this.invalidGrant = errorType === 'invalid_grant';
      }
    },
    async setToken(token) {
      // DOTO: Refactoring
      localStorage.setItem('auth_token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      http.setToken(token);
      laravelHttp.setToken(token);
      refBookHttp.setToken(token);
      receptionHttp.setToken(token);
      await helper.check();
      await this.$store.dispatch('permission/loadPermissions');
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
  },
};
</script>
